import { render, staticRenderFns } from "./BaseStatusV2.vue?vue&type=template&id=3fda4e40&scoped=true"
import script from "./BaseStatusV2.vue?vue&type=script&lang=js"
export * from "./BaseStatusV2.vue?vue&type=script&lang=js"
import style0 from "./BaseStatusV2.vue?vue&type=style&index=0&id=3fda4e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda4e40",
  null
  
)

export default component.exports